/**
 * @generated SignedSource<<099884bdf8f0cf954ab0abc679bb5bbf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RespondQuestionCard_formQuestion$data = {
  readonly definition: {
    readonly __typename: string;
    readonly id: string;
    readonly maxValue?: number;
    readonly minValue?: number;
    readonly options?: ReadonlyArray<{
      readonly text: string;
      readonly value: string;
    }>;
  } | null;
  readonly id: string;
  readonly required: boolean;
  readonly text: string;
  readonly " $fragmentType": "RespondQuestionCard_formQuestion";
};
export type RespondQuestionCard_formQuestion$key = {
  readonly " $data"?: RespondQuestionCard_formQuestion$data;
  readonly " $fragmentSpreads": FragmentRefs<"RespondQuestionCard_formQuestion">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomField__FieldOption",
    "kind": "LinkedField",
    "name": "options",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      },
      (v1/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RespondQuestionCard_formQuestion",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "required",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "definition",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minValue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxValue",
              "storageKey": null
            }
          ],
          "type": "CustomField__Numeric",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "CustomField__Checkboxes",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "CustomField__MultipleChoice",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FormQuestion",
  "abstractKey": null
};
})();

(node as any).hash = "255c2b93bbb1dda38dc2d8e5f2af136a";

export default node;
